import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { RoutingURLs } from "../../../../config/RoutingURLs";
import { ButtonCust } from "../../../widgets";
import { useAppSelector } from "../../../../app/hooks";
import EnvConfig from "../../../../config/env.config.json";
import { gtmTagManager } from "../../../../utils";
import { gaEvents, gaScreenNames } from "../../../../Types/GoogleAnalytics";
enum paymentSuccess {
  PAY_PROGRESS = "PAY_PROGRESS",
  PAY_DONE = "PAY_DONE",
  ACT_START = "ACT_START",
}

export type PayNowPlanProps = {
  content: any;
  miaPaymentCheckDone: any;
  paymentAmount: any;
};

const ActivationLoader = (props: PayNowPlanProps) => {
  const [showPaymentProcess, setShowPaymentProcess] = useState(
    paymentSuccess.PAY_PROGRESS
  );
  const navigate = useNavigate();
  const handleContinueToDashBoard = () => {
    navigate(RoutingURLs.postActivationHome);
  };
  const { content, miaPaymentCheckDone, paymentAmount } = props;
  const { purchase_imges, loader_content } = content;

  const { step1, step2, step3, next_step, btn_text } = loader_content;
  const initialRender1 = useRef(true);

  useEffect(() => {
    if (initialRender1.current) {
      if (miaPaymentCheckDone) {
        localStorage.removeItem("simId")
        setTimeout(() => setShowPaymentProcess(paymentSuccess.PAY_DONE), 2000);
        setTimeout(() => setShowPaymentProcess(paymentSuccess.ACT_START), 5000);
        initialRender1.current = false;
      }
    }
  }, [miaPaymentCheckDone]);
  const line = () => {
    return (
      <Box
        sx={{
          background: "var(--primary_color)",
          borderRadius: "30px",
          height: "4px",
          width: "33.33%",
        }}
      ></Box>
    );
  };

  return (
    <Box
      sx={{
        width: { xs: "90%", sm: "90%", md: "45%", lg: "52%" },
        margin: "0px auto",
        textAlign: "center",
        padding: { xs: "10px", sm: "40px 0px 270px" },
        mt: "40px",
      }}
    >
      <Box
        sx={{
          background: "var(--white)",
          pt: "20px",
          px: "5px",
          // border: "1px solid var(--border_color)",
          borderRadius: "5px",
        }}
      >
        <Box>
          <Box
            key={`${showPaymentProcess}-${purchase_imges?.data?.[0]?.attributes?.url}`}
            component={"img"}
            src={
              showPaymentProcess === paymentSuccess.PAY_PROGRESS
                ? purchase_imges?.data?.[0]?.attributes?.url
                : showPaymentProcess === paymentSuccess.PAY_DONE
                ? purchase_imges?.data?.[1]?.attributes?.url
                : purchase_imges?.data?.[1]?.attributes?.url
            }
            alt={
              showPaymentProcess === paymentSuccess.PAY_PROGRESS
                ? purchase_imges?.data?.[0]?.attributes?.alternativeText
                : showPaymentProcess === paymentSuccess.PAY_DONE
                ? purchase_imges?.data?.[1]?.attributes?.alternativeText
                : purchase_imges?.data?.[1]?.attributes?.alternativeText
            }
            width={"160px !important"}
            height="160px !important"
          />
        </Box>
        <Box>
          <Typography
            component={"p"}
            sx={{
              fontSize: { xs: "18px", sm: "20px" },
              fontFamily: "var(--font_family_Semibold)",
              lineHeight: "27px",
              // mt: "15px",
              // mb: {xs: "35px"},
              p: { xs: "10px 10px 35px 10px", sm:  "0 0 40px 0px"},
              color: 'var(--black)'
            }}
            dangerouslySetInnerHTML={{
              __html:
                showPaymentProcess === paymentSuccess.PAY_PROGRESS
                  ? step1
                  : showPaymentProcess === paymentSuccess.PAY_DONE
                  ? step1
                  : step3,
            }}
          ></Typography>
          {showPaymentProcess === paymentSuccess.ACT_START && (
            <>
              <Typography
                component={"p"}
                sx={{
                  fontSize: { xs: "12px", sm: "14px" },
                  fontFamily: "var(--font_family_Medium)",
                  fontWeight: "500",
                  // lineHeight: "32px",
                  mt: { xs: "-17px", sm: "-15px" },
                  mb: "20px",
                  p: { xs: "10px", sm: "0" },
                }}
                dangerouslySetInnerHTML={{
                  __html: next_step,
                }}
              ></Typography>
              <Box
                sx={{
                  // mb: "35px",
                  pb: "35px"
                }}
              >
                <ButtonCust
                  sx={{
                    fontSize: "16px",
                    lineHeight: "28px",
                    fontFamily: "var(--font_family_Medium)",
                    // textTransform: "uppercase !important",
                    "&:hover": {
                      backgroundColor: "var(--primary_color) !important",
                      border: "1px solid var(--primary_color) !important",
                    },
                    width: "250px",
                  }}
                  variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                  onClick={handleContinueToDashBoard}
                >
                  {btn_text}
                </ButtonCust>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ActivationLoader;
